import _styled from "@emotion/styled-base";

/**
 * Internal dependencies
 */
import { text } from './styles/text-mixins';
import { withNextComponent } from './next';

var Text = _styled("p", {
  target: "e15wbhsk0",
  label: "Text"
})("\n\tbox-sizing: border-box;\n\tmargin: 0;\n", text, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkB3b3JkcHJlc3MvY29tcG9uZW50cy9zcmMvdGV4dC9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXYSIsImZpbGUiOiJAd29yZHByZXNzL2NvbXBvbmVudHMvc3JjL3RleHQvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEV4dGVybmFsIGRlcGVuZGVuY2llc1xuICovXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbi8qKlxuICogSW50ZXJuYWwgZGVwZW5kZW5jaWVzXG4gKi9cbmltcG9ydCB7IHRleHQgfSBmcm9tICcuL3N0eWxlcy90ZXh0LW1peGlucyc7XG5pbXBvcnQgeyB3aXRoTmV4dENvbXBvbmVudCB9IGZyb20gJy4vbmV4dCc7XG5cbmNvbnN0IFRleHQgPSBzdHlsZWQucChcblx0YFxuXHRib3gtc2l6aW5nOiBib3JkZXItYm94O1xuXHRtYXJnaW46IDA7XG5gLFxuXHR0ZXh0XG4pO1xuXG5leHBvcnQgZGVmYXVsdCB3aXRoTmV4dENvbXBvbmVudCggVGV4dCApO1xuIl19 */");

export default withNextComponent(Text);
//# sourceMappingURL=index.js.map